
/*
 * Ev-Entz Kalles Search Fix
 *
 * Ensures pressing Enter uses the current search input,
 * rather than an outdated predictive-search suggestion.
 *
 * Applies only to the Kalles search drawer.
 */

(function () {
  "use strict";

  const inputSelector = '[data-frm-search] [data-input-search]';

  function getSearchInput(target) {
    if (!target || !target.closest) return null;
    return target.closest(inputSelector);
  }

  function submitCurrentSearch(form) {
    const input = form.querySelector('[data-input-search]');
    if (!input) return;

    let query = input.value.trim();
    if (!query) return;

    // Preserve Kalles's optional product-type filter.
    const category = form.querySelector('[data-cat-search] select');

    if (category && category.value && category.value !== '*') {
      query = 'product_type:' + category.value + ' AND ' + query;
    }

    // Retain the existing Shopify search form parameters.
    const params = new URLSearchParams(new FormData(form));
    params.set('q', query);

    const url = new URL(form.getAttribute('action') || '/search',
                        window.location.origin);

    url.search = params.toString();

    window.location.assign(url.toString());
  }

  // Capture Enter before Kalles's predictive-search handlers.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    if (event.isComposing || event.keyCode === 229) return;
    if (event.ctrlKey || event.altKey || event.metaKey) return;

    const input = getSearchInput(event.target);
    if (!input) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const form = input.closest('[data-frm-search]');
    if (form) submitCurrentSearch(form);
  }, true);

  // Prevent the older Kalles keyup handler from opening
  // an outdated predictive-search result.
  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Enter') return;
    if (!getSearchInput(event.target)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  // Also handle search button and mobile keyboard submission.
  document.addEventListener('submit', function (event) {
    const form = event.target;

    if (!form.matches || !form.matches('[data-frm-search]')) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    submitCurrentSearch(form);
  }, true);

})();
